var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.3 8.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c192f3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.15,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.14,
    y: 1.74,
    width: 3.55,
    height: 4.64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 2.25,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 2.76,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 3.26,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 3.77,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 4.28,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 4.79,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 5.3,
    width: 2.58,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.62,
    y: 5.8,
    width: 1.75,
    height: 0.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.6,
    cy: 5.79,
    r: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.6,6.94c-.63,0-1.15-.52-1.15-1.15s.52-1.15,1.15-1.15,1.15,.52,1.15,1.15-.52,1.15-1.15,1.15Zm0-2.16c-.56,0-1.01,.45-1.01,1.01s.45,1.01,1.01,1.01,1.01-.46,1.01-1.01-.45-1.01-1.01-1.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.41,6.37l-.41-.39s-.04-.1,0-.14c.04-.04,.1-.04,.14,0l.25,.24,.68-.76s.1-.05,.14,0c.04,.04,.05,.1,0,.14l-.82,.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidarIcon);
export default __webpack_public_path__ + "static/media/validar_icon.a1a5afa5c85326fb467e8d1e137673d9.svg";
export { ForwardRef as ReactComponent };